import "./index.scss";

export const CarouselSelector = ({ slides, currentSlide, onSelectorHover }) => {
  return (
    <div className="carousel-selector">
      {slides.map(({ cta }, index) => (
        <button
          key={cta}
          className={currentSlide === index ? "active" : ""}
          onMouseEnter={() => onSelectorHover(index)}
        >
          {cta}
        </button>
      ))}
    </div>
  );
};
